import React from 'react';
import PropTypes from 'prop-types';
import { pure } from 'recompose';
import { round } from 'common/numbers';
import { Trend } from '../Trend/Trend';
import IconRestriction from '../Icons/IconRestriction';
import IconException from '../Icons/IconException';
import IconNotes from '../Icons/IconNotes';
import { RowItem, ChartRow } from 'lib/components/_charts/ChartRowAndHeader.styles';
import { TextMedium } from '../../common/text';

const clickHandler = (data, clickFn) => () => clickFn(data.id);

export const PerformanceChartRow = pure(({ data, onClick }) => (
    <ChartRow onClick={clickHandler(data, onClick)} data-testid={`turbine_${data.id}`}>
        <RowItem width="100">
            <TextMedium bold>{data.id}</TextMedium>
        </RowItem>
        <RowItem width="100">
            <TextMedium>{round(data.generation || 0)} MWh</TextMedium>
        </RowItem>
        <RowItem width="100">
            <Trend value={data.average} textComponent={TextMedium} />
        </RowItem>
        <RowItem flex="1">{data.persons > 0 && data.persons}</RowItem>
        <RowItem flex="1">{data.hasNote && <IconNotes size={13} />}</RowItem>
        <RowItem flex="1">{data.hasRestriction && <IconRestriction size={13} />}</RowItem>
        <RowItem flex="1">{data.hasAlarm && <IconException size={13} />}</RowItem>
    </ChartRow>
));

PerformanceChartRow.displayName = 'PerformanceChartRow';

PerformanceChartRow.propTypes = {
    data: PropTypes.object,
    onClick: PropTypes.func,
};

PerformanceChartRow.defaultProps = {};
